import { useEffect } from 'react';
export default function useInteractionStopObserver(dialogRef, setIgnoreContentObserver) {
  useEffect(() => {
    const contentDom = dialogRef.current;
    if (!contentDom) return;
    const stopObserving = () => {
      setIgnoreContentObserver(true);
    };
    contentDom.addEventListener('mousedown', stopObserving);
    contentDom.addEventListener('keydown', stopObserving);
    return () => {
      contentDom.removeEventListener('mousedown', stopObserving);
      contentDom.removeEventListener('keydown', stopObserving);
    };
  }, [dialogRef, setIgnoreContentObserver]);
}
//# sourceMappingURL=useInteractionStopObserver.js.map